import {Inject, Injectable, Injector} from "@angular/core";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import {Router} from "@angular/router";
import { from,Observable, throwError } from 'rxjs';
import { map, catchError, tap,switchMap } from 'rxjs/operators';

import {ToastService} from "../../../../shared/core/services/toast.service";
import {HirAuthApiService} from "./hir-auth.service";

@Injectable()
export class HirAuthRequestInterceptor implements HttpInterceptor{

  constructor(private injector: Injector,
              private router: Router,
              private toastService: ToastService,
              @Inject('APP_PATH') private appPath: string,
              @Inject('APP_NAME') private appName: string) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{

    // let pathname=new URL(req.url).pathname;
    // this is the same as above line, but for compatibility in IE 11
    let pathArr = req.url.split('/');
    for(let i=0; i<3; i++){
      pathArr.shift();
    }

    if(pathArr.find(i => i === 'rms')){
      return next.handle(req).pipe();
    }
    if(pathArr.find(i => i === 'jpats')){
      return next.handle(req).pipe();
    }
    if(pathArr.find(i => i === 'ndms')){
      return next.handle(req).pipe();
    }
    let pathname = '/' + pathArr.join('/');
    if(pathArr[0] === 'identity'
      || pathname=== `${this.appPath}/${this.appName}/unauthorized`
      || pathname=== `${this.appPath}/${this.appName}/__webpack_hmr_jpats`
      || pathname === `${this.appPath}/view/${this.appName}/authenticate`
      || pathname === `${this.appPath}/login/authorized`
      || pathname === `${this.appPath}view/rms/authenticate/RequestToken`
      || pathname === `${this.appPath}view/hir/authenticate/RequestToken`
    ){
      const clone = req.clone();
      return next.handle(clone).pipe(catchError((error: HttpErrorResponse) =>{
        return throwError(error);
      }));
    }
    const authApiService: HirAuthApiService = this.injector.get(HirAuthApiService);

    let authHeader = authApiService.getToken();

    if(!authHeader){
      return from(authApiService.requestToken())
        .pipe(
          switchMap(token => {
            const headers = req.headers
              .set('Authorization', 'Bearer ' + token.model.jwt)
              .append('Content-Type', 'application/json');
            const requestClone = req.clone({
              headers
            });
            return next.handle(requestClone);
          })
        );
    }
    const clone = req.clone({headers: req.headers.set('Authorization',authHeader || "")});
    return next.handle(clone).pipe(catchError((error: HttpErrorResponse) => {
      if(error.status == 401){
        const authApiService: HirAuthApiService= this.injector.get(HirAuthApiService);
        authApiService.authenticate().subscribe(()=>{
          next.handle(clone).pipe();
        });
        return [];
      }
      return throwError(error);
    }) );
  }

}
